// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".import-file_3b9d {\n  display: none;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/Settings/Views/Actions.scss","Actions.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;ACCJ","file":"Actions.scss","sourcesContent":[".import-file {\n    display: none;\n}\n",".import-file {\n  display: none;\n}"]}]);
// Exports
exports.locals = {
	"import-file": "import-file_3b9d"
};
module.exports = exports;
